import { useEffect, useState } from 'react'

/**
 * Detect the user's platform (Mac vs Windows/Linux)
 * Returns null during SSR to avoid hydration mismatch
 */
export function usePlatform() {
  const [isMac, setIsMac] = useState<boolean | null>(null)

  useEffect(() => {
    setIsMac(
      typeof navigator !== 'undefined' &&
        /Mac|iPod|iPhone|iPad/.test(navigator.platform),
    )
  }, [])

  return { isMac }
}
